module.exports = __webpack_public_path__ + "img/mail_ic.90ad5b56.svg";